import { EmptyStatePlaceholder, Link } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { CustomPatientGroupsCreateModalOpener } from './create/CustomPatientGroupsCreateModal.opener';

export const CustomPatientGroupsTableEmptyStatePlaceholder = (): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         heading={translationKeys.noCustomGroups}
         subheading={translationKeys.noCustomGroupsHaveBeenAddedYet}
         testId={'noCustomPatientGroups'}
      >
         <CustomPatientGroupsCreateModalOpener>
            {({ openModal }) => (
               <Link testId={'customPatientGroupCreateLink'} onClick={openModal} label={translationKeys.addGroup} />
            )}
         </CustomPatientGroupsCreateModalOpener>
      </EmptyStatePlaceholder>
   );
};
